/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ConcreteRequest } from 'relay-runtime';
type AggregatesListingPageMeta_listing$ref = any;
type AggregatesListingPageMeta_page$ref = any;
type aggregatesListingDialog_listing$ref = any;
export type aggregatesListingDialogClientQueryVariables = {|
  slug: string,
  lang: string,
|};
export type aggregatesListingDialogClientQueryResponse = {|
  +listing: ?{|
    +$fragmentRefs: aggregatesListingDialog_listing$ref & AggregatesListingPageMeta_listing$ref
  |},
  +cms: {|
    +listingPage: ?{|
      +page: {|
        +$fragmentRefs: AggregatesListingPageMeta_page$ref
      |}
    |}
  |},
|};
export type aggregatesListingDialogClientQuery = {|
  variables: aggregatesListingDialogClientQueryVariables,
  response: aggregatesListingDialogClientQueryResponse,
|};
*/


/*
query aggregatesListingDialogClientQuery(
  $slug: String!
  $lang: String!
) {
  listing: aggregatesListingBySlug(slug: $slug) {
    ...aggregatesListingDialog_listing
    ...AggregatesListingPageMeta_listing
    id
  }
  cms {
    listingPage: pageWithData(uid: "listing", lang: $lang) {
      page {
        ...AggregatesListingPageMeta_page
      }
    }
  }
}

fragment AggregatesListingAnalytics_listing on AggregatesListing {
  id
  encodedId
  slug
  offerType
  propertyType
  compositePropertyType
  numberOfRooms
  numberOfBathrooms
  livingSurface
  landSurface
  salePrice
  grossRentMonthly
  currency
  constructionYear
  locality
  propertyMainType
  stateObject {
    label
    id
  }
  municipalityObject {
    label
    id
  }
  streetNumber
  route
  postcode
  lat
  lng
  agencyName
  agencyReference
  lotReference
}

fragment AggregatesListingBreadcrumbs_listing on AggregatesListing {
  slug
  offerType
  numberOfRooms
  compositePropertyType
  localityObject {
    slug
    lang
    breadcrumbs {
      slug
      lang
      label
      canonicalPlace {
        slug
        id
      }
      id
    }
    id
  }
  ...AggregatesListingH1_listing
}

fragment AggregatesListingCard_listing on AggregatesListing {
  ...useListingStructuredData_listing
  id
  slug
  encodedId
  offerType
  shortDescription: description(sentences: 3)
  shortTranslatedDescription: translatedDescription(sentences: 3)
  bulletPoints
  propertyType
  numberOfRooms
  livingSurface
  isFavourite
  usableSurface
  landSurface
  salePrice
  grossRentMonthly
  grossRentM2yearly
  currency
  postcode
  subLocality
  route
  streetNumber
  images(first: 100) {
    bucketName
    fileName
    blurhash
    id
  }
  url {
    url
    originalDomain
    originalUrl
    mergedListingId
  }
  translatedTitle
  salePricePerLivingSurface
  salePricePerLandSurface
  createdAt
  propertyMainType
  compositePropertyType
  visitContactPerson
  agencyName
  agencyReference
  lotReference
  constructionYear
  locality
  stateObject {
    label
    id
  }
  municipalityObject {
    label
    id
  }
  lat
  lng
  address
  numberOfBathrooms
}

fragment AggregatesListingCharacteristics_listing on AggregatesListing {
  hasBalcony
  hasGarden
  hasParking
  hasElevator
  hasView
  hasFireplace
  hasGarage
  isChildFriendly
  isWheelchairAccessible
  isMinergieCertified
  isNewDevelopment
  hasLavatoryConnection
  hasGasSupply
  hasSewerageSupply
  hasCellar
  hasWaterSupply
  hasStorageRoom
  hasDishWasher
  hasPlayGround
  hasVirtualTour
  hasRestrooms
  hasCableTv
  hasWashingMachine
  hasTumbleDryer
  hasInternet
  isGroundfloorRaised
  isHighlighted
  isAnimalFriendly
  isOldBuilding
  secondaryResidenceEligible
  hasNewBuildingProject
  distPublicTransportation
  distShopping
  distKindergarten
  distElementarySchool
  distHighSchool
  distMotorWay
}

fragment AggregatesListingEnergyDiagnostics_listing on AggregatesListing {
  energyClass
  greenhouseGasEmissionsClass
  energyIndex
  greenhouseGasEmissionsIndex
  energyCertificateVersion
  energyInspectionDate
  energyReferenceYear
  energyCostCurrency
  estimatedLowerEnergyCost
  estimatedHigherEnergyCost
}

fragment AggregatesListingH1_listing on AggregatesListing {
  offerType
  postcode
  subLocality
  route
  streetNumber
  propertyMainType
  propertyType
}

fragment AggregatesListingPageMeta_listing on AggregatesListing {
  title
  description
  offerType
  propertyType
  propertyMainType
  lat
  lng
  postcode
  subLocality
  route
  streetNumber
  livingSurface
  numberOfRooms
  numberOfBathrooms
  salePrice
  grossRentMonthly
  currency
  images(first: 100) {
    bucketName
    fileName
    id
  }
}

fragment AggregatesListingPageMeta_page on CMSPage {
  title
  description
}

fragment AggregatesListingPriceCardContent_listing on AggregatesListing {
  createdAt
  currency
  offlineSince
}

fragment AggregatesListingPriceCard_listing on AggregatesListing {
  ...AggregatesListingPriceCardContent_listing
  ...aggregatesListingCampaignEnquiry_listing
  salePrice
  offerType
  grossRentMonthly
  grossRentM2yearly
  salePricePerLivingSurface
  salePricePerLandSurface
  currency
  offlineSince
  createdAt
  bookOnline
  id
  slug
  agencyId
  agencyName
  agencySlug
  agencyLogoUrl
  agencyRating
  agencyReviewsCount
  agencyReference
  agencyContactPhoneNumber
  visitContactPerson
  visitContactPhoneNumber
  url {
    originalDomain
  }
  urls {
    url
    originalDomain
    mergedListingId
  }
}

fragment AggregatesListingPropertyDetails_listing on AggregatesListing {
  livingSurface
  usableSurface
  gardenSurface
  terraceSurface
  balconySurface
  landSurface
  numberOfRooms
  numberOfBedrooms
  numberOfBathrooms
  availableFrom
  constructionYear
  renovationYear
  floorOfFlat
  numberOfLevels
  volume
  numberOfIndoorParkings
  numberOfOutdoorParkings
  numberOfToilets
  url {
    originalDomain
  }
}

fragment AggregatesListingStructuredData_listing on AggregatesListing {
  ...useListingStructuredData_listing
  offerType
  compositePropertyType
  slug
  description
  translatedDescription
}

fragment AggregatesListing_listing on AggregatesListing {
  ...AggregatesListingAnalytics_listing
  ...AggregatesListingStructuredData_listing
  ...aggregatesListingMap_listing
  ...aggregatesListingCampaignEnquiry_listing
  id
  encodedId
  isListingCampaign
  isIdxListing
  offlineSince
  slug
  listingLanguage
  title
  translatedTitle
  livingSurface
  landSurface
  computedSurface
  offerType
  salePrice
  salePricePerLivingSurface
  salePricePerLandSurface
  grossRentMonthly
  grossRentM2yearly
  currency
  postcode
  route
  address
  streetNumber
  agencyId
  agencyName
  agencySlug
  agencyLogoUrl
  agencyRating
  agencyReviewsCount
  agencyContactPhoneNumber
  visitContactPerson
  visitContactPhoneNumber
  agencyReference
  lotReference
  images(first: 100) {
    bucketName
    fileName
    blurhash
    id
  }
  similarListings(count: 4) {
    id
    encodedId
    slug
    title
    offerType
    currency
    salePrice
    grossRentMonthly
    constructionYear
    renovationYear
    livingSurface
    landSurface
    computedSurface
    numberOfRooms
    numberOfBathrooms
    numberOfParking
    propertyMainType
    propertyType
    compositePropertyType
    portal
    agencyId
    agencyName
    route
    streetNumber
    postcode
    subLocality
    locality
    lat
    lng
    url {
      url
    }
    ...AggregatesListingCard_listing
  }
  numberOfRooms
  numberOfBathrooms
  numberOfParking
  propertyType
  propertyMainType
  compositePropertyType
  portal
  constructionYear
  renovationYear
  ...AggregatesListingBreadcrumbs_listing
  ...AggregatesListingPropertyDetails_listing
  ...AggregatesListingCharacteristics_listing
  ...AggregatesListingPriceCard_listing
  ...AggregatesListingPriceCardContent_listing
  ...AggregatesListingH1_listing
  ...AggregatesListingEnergyDiagnostics_listing
  url {
    url
    originalDomain
  }
  bookOnline
  urls {
    url
    originalDomain
    mergedListingId
  }
  locality
  subLocality
  localityObject {
    label
    slug
    canonicalPlace {
      label
      slug
      id
    }
    id
  }
  municipalityObject {
    label
    slug
    objectId
    id
  }
  stateObject {
    label
    extra {
      canton_code
    }
    id
  }
  lat
  lng
  description
  translatedDescription
  agencyReferences
  similarListingsStats {
    saleOffersCount
    rentOffersCount
  }
}

fragment aggregatesListingCampaignEnquiry_listing on AggregatesListing {
  id
  originalId
  encodedId
  slug
  offerType
  propertyType
  propertyMainType
  compositePropertyType
  numberOfRooms
  numberOfBathrooms
  livingSurface
  landSurface
  salePrice
  grossRentMonthly
  currency
  constructionYear
  locality
  stateObject {
    label
    id
  }
  municipalityObject {
    label
    id
  }
  streetNumber
  route
  postcode
  lat
  lng
  agencyName
  agencyReference
  lotReference
  url {
    originalDomain
    url
  }
}

fragment aggregatesListingDialog_listing on AggregatesListing {
  ...AggregatesListing_listing
}

fragment aggregatesListingMap_listing on AggregatesListing {
  slug
  mapData {
    point {
      lat
      lng
    }
    area(lowRes: true) {
      coordinates
    }
  }
}

fragment useListingStructuredData_listing on AggregatesListing {
  currency
  images(first: 100) {
    bucketName
    fileName
    id
  }
  grossRentMonthly
  livingSurface
  numberOfRooms
  postcode
  propertyMainType
  lat
  lng
  propertyType
  route
  salePrice
  streetNumber
  subLocality
  encodedId
  offerType
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "lang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slug"
},
v2 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "lang",
    "variableName": "lang"
  },
  {
    "kind": "Literal",
    "name": "uid",
    "value": "listing"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "encodedId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "offerType",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyType",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "compositePropertyType",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfRooms",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfBathrooms",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "livingSurface",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "landSurface",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salePrice",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grossRentMonthly",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "constructionYear",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locality",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "propertyMainType",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "streetNumber",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "route",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "postcode",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lng",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agencyName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agencyReference",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lotReference",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 100
    }
  ],
  "concreteType": "AggregatesListingImage",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "bucketName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fileName",
      "storageKey": null
    },
    (v4/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "blurhash",
      "storageKey": null
    }
  ],
  "storageKey": "images(first:100)"
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "subLocality",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalDomain",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "translatedTitle",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "computedSurface",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salePricePerLivingSurface",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salePricePerLandSurface",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "grossRentM2yearly",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "agencyId",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visitContactPerson",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "renovationYear",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfParking",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "portal",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mergedListingId",
  "storageKey": null
},
v47 = [
  {
    "kind": "Literal",
    "name": "sentences",
    "value": 3
  }
],
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usableSurface",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v50 = [
  (v20/*: any*/),
  (v4/*: any*/)
],
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lang",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "aggregatesListingDialogClientQuery",
    "selections": [
      {
        "alias": "listing",
        "args": (v2/*: any*/),
        "concreteType": "AggregatesListing",
        "kind": "LinkedField",
        "name": "aggregatesListingBySlug",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "aggregatesListingDialog_listing"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "AggregatesListingPageMeta_listing"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CMS",
        "kind": "LinkedField",
        "name": "cms",
        "plural": false,
        "selections": [
          {
            "alias": "listingPage",
            "args": (v3/*: any*/),
            "concreteType": "CMSPageWithData",
            "kind": "LinkedField",
            "name": "pageWithData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSPage",
                "kind": "LinkedField",
                "name": "page",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AggregatesListingPageMeta_page"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "aggregatesListingDialogClientQuery",
    "selections": [
      {
        "alias": "listing",
        "args": (v2/*: any*/),
        "concreteType": "AggregatesListing",
        "kind": "LinkedField",
        "name": "aggregatesListingBySlug",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Place",
            "kind": "LinkedField",
            "name": "stateObject",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PlaceExtraType",
                "kind": "LinkedField",
                "name": "extra",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canton_code",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Place",
            "kind": "LinkedField",
            "name": "municipalityObject",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v4/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "objectId",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "translatedDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AggregatesListingMapData",
            "kind": "LinkedField",
            "name": "mapData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Coordinates",
                "kind": "LinkedField",
                "name": "point",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  (v25/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "lowRes",
                    "value": true
                  }
                ],
                "concreteType": "GeoJSONMultiPolygon",
                "kind": "LinkedField",
                "name": "area",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "coordinates",
                    "storageKey": null
                  }
                ],
                "storageKey": "area(lowRes:true)"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "originalId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ExternalUrl",
            "kind": "LinkedField",
            "name": "url",
            "plural": false,
            "selections": [
              (v32/*: any*/),
              (v33/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isListingCampaign",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isIdxListing",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offlineSince",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "listingLanguage",
            "storageKey": null
          },
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          (v41/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agencySlug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agencyLogoUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agencyRating",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agencyReviewsCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agencyContactPhoneNumber",
            "storageKey": null
          },
          (v42/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "visitContactPhoneNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "count",
                "value": 4
              }
            ],
            "concreteType": "AggregatesListing",
            "kind": "LinkedField",
            "name": "similarListings",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v34/*: any*/),
              (v7/*: any*/),
              (v16/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v17/*: any*/),
              (v43/*: any*/),
              (v12/*: any*/),
              (v13/*: any*/),
              (v36/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v44/*: any*/),
              (v19/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v45/*: any*/),
              (v41/*: any*/),
              (v26/*: any*/),
              (v22/*: any*/),
              (v21/*: any*/),
              (v23/*: any*/),
              (v30/*: any*/),
              (v18/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ExternalUrl",
                "kind": "LinkedField",
                "name": "url",
                "plural": false,
                "selections": [
                  (v33/*: any*/),
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "originalUrl",
                    "storageKey": null
                  },
                  (v46/*: any*/)
                ],
                "storageKey": null
              },
              (v29/*: any*/),
              {
                "alias": "shortDescription",
                "args": (v47/*: any*/),
                "kind": "ScalarField",
                "name": "description",
                "storageKey": "description(sentences:3)"
              },
              {
                "alias": "shortTranslatedDescription",
                "args": (v47/*: any*/),
                "kind": "ScalarField",
                "name": "translatedDescription",
                "storageKey": "translatedDescription(sentences:3)"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "bulletPoints",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isFavourite",
                "storageKey": null
              },
              (v48/*: any*/),
              (v39/*: any*/),
              (v35/*: any*/),
              (v37/*: any*/),
              (v38/*: any*/),
              (v49/*: any*/),
              (v42/*: any*/),
              (v27/*: any*/),
              (v28/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Place",
                "kind": "LinkedField",
                "name": "stateObject",
                "plural": false,
                "selections": (v50/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Place",
                "kind": "LinkedField",
                "name": "municipalityObject",
                "plural": false,
                "selections": (v50/*: any*/),
                "storageKey": null
              },
              (v40/*: any*/)
            ],
            "storageKey": "similarListings(count:4)"
          },
          (v44/*: any*/),
          (v45/*: any*/),
          (v43/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Place",
            "kind": "LinkedField",
            "name": "localityObject",
            "plural": false,
            "selections": [
              (v6/*: any*/),
              (v51/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Place",
                "kind": "LinkedField",
                "name": "breadcrumbs",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v51/*: any*/),
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Place",
                    "kind": "LinkedField",
                    "name": "canonicalPlace",
                    "plural": false,
                    "selections": [
                      (v6/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              (v4/*: any*/),
              (v20/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Place",
                "kind": "LinkedField",
                "name": "canonicalPlace",
                "plural": false,
                "selections": [
                  (v20/*: any*/),
                  (v6/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v48/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gardenSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "terraceSurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "balconySurface",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numberOfBedrooms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "availableFrom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "floorOfFlat",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numberOfLevels",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "volume",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numberOfIndoorParkings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numberOfOutdoorParkings",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "numberOfToilets",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasBalcony",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasGarden",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasParking",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasElevator",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasView",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasFireplace",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasGarage",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isChildFriendly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isWheelchairAccessible",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isMinergieCertified",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isNewDevelopment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasLavatoryConnection",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasGasSupply",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasSewerageSupply",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasCellar",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasWaterSupply",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasStorageRoom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasDishWasher",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasPlayGround",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasVirtualTour",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasRestrooms",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasCableTv",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasWashingMachine",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasTumbleDryer",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasInternet",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isGroundfloorRaised",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isHighlighted",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isAnimalFriendly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isOldBuilding",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "secondaryResidenceEligible",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNewBuildingProject",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "distPublicTransportation",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "distShopping",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "distKindergarten",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "distElementarySchool",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "distHighSchool",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "distMotorWay",
            "storageKey": null
          },
          (v49/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bookOnline",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ExternalUrl",
            "kind": "LinkedField",
            "name": "urls",
            "plural": true,
            "selections": [
              (v33/*: any*/),
              (v32/*: any*/),
              (v46/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "energyClass",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "greenhouseGasEmissionsClass",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "energyIndex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "greenhouseGasEmissionsIndex",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "energyCertificateVersion",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "energyInspectionDate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "energyReferenceYear",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "energyCostCurrency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimatedLowerEnergyCost",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "estimatedHigherEnergyCost",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "agencyReferences",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ListingsStats",
            "kind": "LinkedField",
            "name": "similarListingsStats",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "saleOffersCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "rentOffersCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "CMS",
        "kind": "LinkedField",
        "name": "cms",
        "plural": false,
        "selections": [
          {
            "alias": "listingPage",
            "args": (v3/*: any*/),
            "concreteType": "CMSPageWithData",
            "kind": "LinkedField",
            "name": "pageWithData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CMSPage",
                "kind": "LinkedField",
                "name": "page",
                "plural": false,
                "selections": [
                  (v34/*: any*/),
                  (v31/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "90daf57feb667f660700e058d41559cd",
    "id": null,
    "metadata": {},
    "name": "aggregatesListingDialogClientQuery",
    "operationKind": "query",
    "text": "query aggregatesListingDialogClientQuery(\n  $slug: String!\n  $lang: String!\n) {\n  listing: aggregatesListingBySlug(slug: $slug) {\n    ...aggregatesListingDialog_listing\n    ...AggregatesListingPageMeta_listing\n    id\n  }\n  cms {\n    listingPage: pageWithData(uid: \"listing\", lang: $lang) {\n      page {\n        ...AggregatesListingPageMeta_page\n      }\n    }\n  }\n}\n\nfragment AggregatesListingAnalytics_listing on AggregatesListing {\n  id\n  encodedId\n  slug\n  offerType\n  propertyType\n  compositePropertyType\n  numberOfRooms\n  numberOfBathrooms\n  livingSurface\n  landSurface\n  salePrice\n  grossRentMonthly\n  currency\n  constructionYear\n  locality\n  propertyMainType\n  stateObject {\n    label\n    id\n  }\n  municipalityObject {\n    label\n    id\n  }\n  streetNumber\n  route\n  postcode\n  lat\n  lng\n  agencyName\n  agencyReference\n  lotReference\n}\n\nfragment AggregatesListingBreadcrumbs_listing on AggregatesListing {\n  slug\n  offerType\n  numberOfRooms\n  compositePropertyType\n  localityObject {\n    slug\n    lang\n    breadcrumbs {\n      slug\n      lang\n      label\n      canonicalPlace {\n        slug\n        id\n      }\n      id\n    }\n    id\n  }\n  ...AggregatesListingH1_listing\n}\n\nfragment AggregatesListingCard_listing on AggregatesListing {\n  ...useListingStructuredData_listing\n  id\n  slug\n  encodedId\n  offerType\n  shortDescription: description(sentences: 3)\n  shortTranslatedDescription: translatedDescription(sentences: 3)\n  bulletPoints\n  propertyType\n  numberOfRooms\n  livingSurface\n  isFavourite\n  usableSurface\n  landSurface\n  salePrice\n  grossRentMonthly\n  grossRentM2yearly\n  currency\n  postcode\n  subLocality\n  route\n  streetNumber\n  images(first: 100) {\n    bucketName\n    fileName\n    blurhash\n    id\n  }\n  url {\n    url\n    originalDomain\n    originalUrl\n    mergedListingId\n  }\n  translatedTitle\n  salePricePerLivingSurface\n  salePricePerLandSurface\n  createdAt\n  propertyMainType\n  compositePropertyType\n  visitContactPerson\n  agencyName\n  agencyReference\n  lotReference\n  constructionYear\n  locality\n  stateObject {\n    label\n    id\n  }\n  municipalityObject {\n    label\n    id\n  }\n  lat\n  lng\n  address\n  numberOfBathrooms\n}\n\nfragment AggregatesListingCharacteristics_listing on AggregatesListing {\n  hasBalcony\n  hasGarden\n  hasParking\n  hasElevator\n  hasView\n  hasFireplace\n  hasGarage\n  isChildFriendly\n  isWheelchairAccessible\n  isMinergieCertified\n  isNewDevelopment\n  hasLavatoryConnection\n  hasGasSupply\n  hasSewerageSupply\n  hasCellar\n  hasWaterSupply\n  hasStorageRoom\n  hasDishWasher\n  hasPlayGround\n  hasVirtualTour\n  hasRestrooms\n  hasCableTv\n  hasWashingMachine\n  hasTumbleDryer\n  hasInternet\n  isGroundfloorRaised\n  isHighlighted\n  isAnimalFriendly\n  isOldBuilding\n  secondaryResidenceEligible\n  hasNewBuildingProject\n  distPublicTransportation\n  distShopping\n  distKindergarten\n  distElementarySchool\n  distHighSchool\n  distMotorWay\n}\n\nfragment AggregatesListingEnergyDiagnostics_listing on AggregatesListing {\n  energyClass\n  greenhouseGasEmissionsClass\n  energyIndex\n  greenhouseGasEmissionsIndex\n  energyCertificateVersion\n  energyInspectionDate\n  energyReferenceYear\n  energyCostCurrency\n  estimatedLowerEnergyCost\n  estimatedHigherEnergyCost\n}\n\nfragment AggregatesListingH1_listing on AggregatesListing {\n  offerType\n  postcode\n  subLocality\n  route\n  streetNumber\n  propertyMainType\n  propertyType\n}\n\nfragment AggregatesListingPageMeta_listing on AggregatesListing {\n  title\n  description\n  offerType\n  propertyType\n  propertyMainType\n  lat\n  lng\n  postcode\n  subLocality\n  route\n  streetNumber\n  livingSurface\n  numberOfRooms\n  numberOfBathrooms\n  salePrice\n  grossRentMonthly\n  currency\n  images(first: 100) {\n    bucketName\n    fileName\n    id\n  }\n}\n\nfragment AggregatesListingPageMeta_page on CMSPage {\n  title\n  description\n}\n\nfragment AggregatesListingPriceCardContent_listing on AggregatesListing {\n  createdAt\n  currency\n  offlineSince\n}\n\nfragment AggregatesListingPriceCard_listing on AggregatesListing {\n  ...AggregatesListingPriceCardContent_listing\n  ...aggregatesListingCampaignEnquiry_listing\n  salePrice\n  offerType\n  grossRentMonthly\n  grossRentM2yearly\n  salePricePerLivingSurface\n  salePricePerLandSurface\n  currency\n  offlineSince\n  createdAt\n  bookOnline\n  id\n  slug\n  agencyId\n  agencyName\n  agencySlug\n  agencyLogoUrl\n  agencyRating\n  agencyReviewsCount\n  agencyReference\n  agencyContactPhoneNumber\n  visitContactPerson\n  visitContactPhoneNumber\n  url {\n    originalDomain\n  }\n  urls {\n    url\n    originalDomain\n    mergedListingId\n  }\n}\n\nfragment AggregatesListingPropertyDetails_listing on AggregatesListing {\n  livingSurface\n  usableSurface\n  gardenSurface\n  terraceSurface\n  balconySurface\n  landSurface\n  numberOfRooms\n  numberOfBedrooms\n  numberOfBathrooms\n  availableFrom\n  constructionYear\n  renovationYear\n  floorOfFlat\n  numberOfLevels\n  volume\n  numberOfIndoorParkings\n  numberOfOutdoorParkings\n  numberOfToilets\n  url {\n    originalDomain\n  }\n}\n\nfragment AggregatesListingStructuredData_listing on AggregatesListing {\n  ...useListingStructuredData_listing\n  offerType\n  compositePropertyType\n  slug\n  description\n  translatedDescription\n}\n\nfragment AggregatesListing_listing on AggregatesListing {\n  ...AggregatesListingAnalytics_listing\n  ...AggregatesListingStructuredData_listing\n  ...aggregatesListingMap_listing\n  ...aggregatesListingCampaignEnquiry_listing\n  id\n  encodedId\n  isListingCampaign\n  isIdxListing\n  offlineSince\n  slug\n  listingLanguage\n  title\n  translatedTitle\n  livingSurface\n  landSurface\n  computedSurface\n  offerType\n  salePrice\n  salePricePerLivingSurface\n  salePricePerLandSurface\n  grossRentMonthly\n  grossRentM2yearly\n  currency\n  postcode\n  route\n  address\n  streetNumber\n  agencyId\n  agencyName\n  agencySlug\n  agencyLogoUrl\n  agencyRating\n  agencyReviewsCount\n  agencyContactPhoneNumber\n  visitContactPerson\n  visitContactPhoneNumber\n  agencyReference\n  lotReference\n  images(first: 100) {\n    bucketName\n    fileName\n    blurhash\n    id\n  }\n  similarListings(count: 4) {\n    id\n    encodedId\n    slug\n    title\n    offerType\n    currency\n    salePrice\n    grossRentMonthly\n    constructionYear\n    renovationYear\n    livingSurface\n    landSurface\n    computedSurface\n    numberOfRooms\n    numberOfBathrooms\n    numberOfParking\n    propertyMainType\n    propertyType\n    compositePropertyType\n    portal\n    agencyId\n    agencyName\n    route\n    streetNumber\n    postcode\n    subLocality\n    locality\n    lat\n    lng\n    url {\n      url\n    }\n    ...AggregatesListingCard_listing\n  }\n  numberOfRooms\n  numberOfBathrooms\n  numberOfParking\n  propertyType\n  propertyMainType\n  compositePropertyType\n  portal\n  constructionYear\n  renovationYear\n  ...AggregatesListingBreadcrumbs_listing\n  ...AggregatesListingPropertyDetails_listing\n  ...AggregatesListingCharacteristics_listing\n  ...AggregatesListingPriceCard_listing\n  ...AggregatesListingPriceCardContent_listing\n  ...AggregatesListingH1_listing\n  ...AggregatesListingEnergyDiagnostics_listing\n  url {\n    url\n    originalDomain\n  }\n  bookOnline\n  urls {\n    url\n    originalDomain\n    mergedListingId\n  }\n  locality\n  subLocality\n  localityObject {\n    label\n    slug\n    canonicalPlace {\n      label\n      slug\n      id\n    }\n    id\n  }\n  municipalityObject {\n    label\n    slug\n    objectId\n    id\n  }\n  stateObject {\n    label\n    extra {\n      canton_code\n    }\n    id\n  }\n  lat\n  lng\n  description\n  translatedDescription\n  agencyReferences\n  similarListingsStats {\n    saleOffersCount\n    rentOffersCount\n  }\n}\n\nfragment aggregatesListingCampaignEnquiry_listing on AggregatesListing {\n  id\n  originalId\n  encodedId\n  slug\n  offerType\n  propertyType\n  propertyMainType\n  compositePropertyType\n  numberOfRooms\n  numberOfBathrooms\n  livingSurface\n  landSurface\n  salePrice\n  grossRentMonthly\n  currency\n  constructionYear\n  locality\n  stateObject {\n    label\n    id\n  }\n  municipalityObject {\n    label\n    id\n  }\n  streetNumber\n  route\n  postcode\n  lat\n  lng\n  agencyName\n  agencyReference\n  lotReference\n  url {\n    originalDomain\n    url\n  }\n}\n\nfragment aggregatesListingDialog_listing on AggregatesListing {\n  ...AggregatesListing_listing\n}\n\nfragment aggregatesListingMap_listing on AggregatesListing {\n  slug\n  mapData {\n    point {\n      lat\n      lng\n    }\n    area(lowRes: true) {\n      coordinates\n    }\n  }\n}\n\nfragment useListingStructuredData_listing on AggregatesListing {\n  currency\n  images(first: 100) {\n    bucketName\n    fileName\n    id\n  }\n  grossRentMonthly\n  livingSurface\n  numberOfRooms\n  postcode\n  propertyMainType\n  lat\n  lng\n  propertyType\n  route\n  salePrice\n  streetNumber\n  subLocality\n  encodedId\n  offerType\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '91ac04efdf569144c230e08c0ebd8526';

export default node;
